<template>
  <v-card id="listener_cambio_bobina">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Cambio Bobina</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-10"
            @click="confermaCambio('manuale')"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success" large> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Conferma</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" v-bind="attrs" v-on="on">
            <v-icon color="error" large> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-card
        outlined
        v-if="
          chk_range_produzione === false &&
          id_causale_sel != id_bobina_esaurita &&
          id_causale_sel != id_bobina_eccessiva &&
          id_causale_sel != id_non_conf &&
          id_causale_sel != id_scarto_prod &&
          dichiarazione_avvenuta === false &&
          mat_nok_avvenuta === false
        "
      >
        <v-card-text>
          <div class="my-3" style="font-size: 20px">
            Scatole previste per la bobina attuale:
            <span
              ><b>{{ scatole_previste }}</b></span
            >
          </div>
          <div class="my-3" style="font-size: 20px">
            Scatole prodotte con la bobina attuale:
            <span
              ><b>{{
                scatole_prodotte === null || scatole_prodotte === undefined
                  ? "N/A"
                  : scatole_prodotte
              }}</b></span
            >
          </div>
          <div class="my-3" style="font-size: 20px">
            Scatole da produrre:
            <span>
              <b>
                <span class="mr-3">{{ differenza }}</span>
              </b>
            </span>
          </div>
          <div class="my-3" style="font-size: 20px">
            Consumo bobina:
            <span>
              <b>
                {{
                  percentuale_consumo != Infinity
                    ? `${percentuale_consumo}%`
                    : "N/A"
                }}
              </b>
            </span>
          </div>
        </v-card-text>
      </v-card>
      <v-container>
        <v-row
          align="center"
          justify="center"
          v-if="
            chk_range_produzione === false &&
            id_causale_sel != id_bobina_esaurita &&
            id_causale_sel != id_bobina_eccessiva &&
            id_causale_sel != id_non_conf &&
            id_causale_sel != id_scarto_prod &&
            dichiarazione_avvenuta === false &&
            mat_nok_avvenuta === false
          "
        >
          <v-col cols="12">
            <div>
              <span style="font-size: 18px"
                >Seleziona la causale per giustificare la differenza:</span
              >
            </div>
            <div style="display: inline-block">
              <v-select
                :items="array_causale"
                v-model="id_causale_sel"
                item-text="des"
                item-value="id_tabella"
                background-color="#ffffff"
                class="ml-5"
                dense
                height="50px"
                hide-details
                style="display: inline-block; padding: 0px; max-width: 260px"
                label="Causale"
              />
            </div>
          </v-col>
        </v-row>

        <!-- Riga di scelta dopo registrazione scarto bobina -->
        <v-row
          align="center"
          justify="center"
          v-show="mat_nok_avvenuta === true"
        >
          <v-card class="elevation-0" outlined>
            <v-card-text>
              <span style="font-size: 18px">
                Vuoi terminare la procedura o procedere al cambio di una nuova
                bobina?
              </span>
            </v-card-text>
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="6"
                  ><v-btn @click="clickChiudi"
                    ><span style="color: #1976d2">FINE</span></v-btn
                  ></v-col
                >
                <v-col cols="6">
                  <v-btn @click="clickCambioAftMatNokOk">
                    <span style="color: #1976d2">CAMBIA BOBINA</span></v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>

        <!-- Riga di invio del QR code della bobina di cambio -->
        <v-row
          align="center"
          justify="center"
          v-if="
            chk_range_produzione === true ||
            id_causale_sel === id_bobina_esaurita ||
            id_causale_sel === id_bobina_eccessiva ||
            id_causale_sel === id_scarto_prod ||
            dichiarazione_avvenuta === true ||
            cambio_aft_mat_nok === true
          "
        >
          <v-col align="center" cols="12" justify="center">
            <div class="mb-5">
              <span style="font-size: 20px">
                Scansiona la bobina successiva
              </span>
            </div>
            <div>
              <div class="mr-5" style="display: inline-block">
                <v-btn @click="clickQRCode" large>
                  <v-icon color="indigo" large> mdi-qrcode-scan </v-icon>
                </v-btn>
              </div>
              <div style="display: inline-block">
                <v-text-field
                  background-color="#ffffff"
                  class="input-class centered-input"
                  dense
                  height="50px"
                  hide-details
                  label=""
                  style="
                    display: inline-block;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 25px;
                    padding: 0px;
                  "
                  v-model="cod_bobina"
                >
                </v-text-field>
              </div>

              <!-- Bottone dell'editor di immagini -->
              <div
                class="ml-5"
                style="display: inline-block"
                v-if="id_causale_sel != null"
              >
                <v-btn @click="clickCamera" large>
                  <v-icon color="indigo" large> mdi-camera </v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col cols="12" v-show="img != ''">
            <!-- Spazio della miniatura -->
            <div class="mr-5" style="display: inline-block">
              <div
                :id="1234"
                style="
                  background-repeat: no-repeat;
                  background-size: contain;
                  border: 1px solid black;
                  height: 150px;
                  margin-top: 5px;
                  position: relative;
                  width: 150px;
                "
              ></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di controllo qualità -->
    <v-dialog v-model="qr_reader_visible" persistent>
      <v-toolbar>
        <v-toolbar-title> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="handleCloseQRDialog" v-bind="attrs" v-on="on">
              <v-icon color="error" large> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <qrcode-stream
        class="qr"
        :camera="camera"
        @decode="handleOnDecode"
      ></qrcode-stream>
    </v-dialog>

    <!-- Dialog del form mancata dichiarazione-->
    <v-dialog persistent v-model="dialog_mancata_dichiarazione" width="600px">
      <FormMancataDichiarazione
        @click_chiudi="chiudiDialogMancataDichiarazione"
        @dichiarazione_avvenuta="handleDichAvv"
        :pz_per_scatola="pz_per_scatola"
      />
    </v-dialog>

    <!-- Dialog di termina produzione -->
    <v-dialog persistent v-model="termina_produzione_visible" width="unset">
      <TerminaProduzione
        @click_chiudi="handleCloseTermProd"
        :from_padre="'CambioBobina'"
        @mat_nok_avv="handleMatNokAvv"
        :work_order_sel="work_order_sel"
        :id_causale_sel="id_causale_sel"
      />
    </v-dialog>

    <!-- Dialog dell'editor di immagini -->
    <v-dialog persistent v-model="controllo_webcam_visible">
      <Controllo
        @click_indietro="controllo_webcam_visible = false"
        :destinazione="'listener_cambio_bobina'"
        :immagine_standard_editor="img"
        :riferimento="1234"
        :tabella_supporto="''"
        :visible="controllo_webcam_visible"
      />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import FormMancataDichiarazione from "@/components/PRODUCTION/Produzione/FormMancataDichiarazione.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TerminaProduzione from "@/components/PRODUCTION/Produzione/TerminaProduzione.vue";

export default {
  name: "CambioBobina",
  components: {
    Controllo,
    FormMancataDichiarazione,
    SnackbarQV,
    TerminaProduzione,
  },
  props: {
    pz_per_scatola: { type: Number, default: 0 },
    scatole_previste: { type: Number, default: 0 },
    visible: { type: Boolean, default: false },
    work_order_sel: {
      type: Object,
      default: () => {
        return {
          quantita: 0,
        };
      },
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_bobina: "",
      dichiarazione_avvenuta: false,
      id_bobina_eccessiva: null,
      id_bobina_esaurita: null,
      id_mancata_dichiarazione: null,
      id_non_conf: null,
      id_scarto_prod: null,
      id_causale_sel: null,
      img: "",
      mat_nok_avvenuta: false,
      progressivo_scatole: null,
      scatole_prodotte: null,

      // Modal
      cambio_aft_mat_nok: false,
      camera: "off",
      caricamento_dati: false,
      controllo_webcam_visible: false,
      qr_reader_visible: false,
      dialog_mancata_dichiarazione: false,
      termina_produzione_visible: false,

      // Array
      array_causale: [],
    };
  },
  computed: {
    differenza() {
      let scatole_previste_tmp =
        this.work_order_sel.quantita > this.scatole_previste
          ? this.scatole_previste
          : this.work_order_sel.quantita;
      let scatole_prodotte_tmp =
        this.scatole_prodotte === null || this.scatole_prodotte === undefined
          ? 0
          : this.scatole_prodotte;

      return scatole_previste_tmp - scatole_prodotte_tmp;
    },
    percentuale_consumo() {
      let scatole_previste_tmp =
        this.work_order_sel.quantita > this.scatole_previste
          ? this.scatole_previste
          : this.work_order_sel.quantita;
      let scatole_prodotte_tmp =
        this.scatole_prodotte === null || this.scatole_prodotte === undefined
          ? 0
          : this.scatole_prodotte;
      return parseFloat(
        (scatole_prodotte_tmp * 100) / scatole_previste_tmp
      ).toFixed(4);
    },
    chk_range_produzione() {
      if (this.percentuale_consumo < 85 || this.percentuale_consumo > 115) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    id_causale_sel: {
      immediate: true,
      handler() {
        // Se la causale è la mancata dichiarazione...
        if (
          this.id_causale_sel != null &&
          this.id_causale_sel === this.id_mancata_dichiarazione
        ) {
          this.dialog_mancata_dichiarazione = true;
        } else if (
          // Se la causale è la non conformità della materia prima...
          this.id_causale_sel != null &&
          this.id_causale_sel === this.id_non_conf
        ) {
          this.termina_produzione_visible = true;
        } else if (
          // Se la causale è la bobina grande...
          this.id_causale_sel != null &&
          this.id_causale_sel === this.id_bobina_eccessiva
        ) {
          this.$refs.SnackbarQV.print(
            "success",
            "Registrata bobina troppo grande, inserire codice bobina successiva.",
            10000
          );
        } else if (
          // Se la causale è la bobina piccola...
          this.id_causale_sel != null &&
          this.id_causale_sel === this.id_bobina_esaurita
        ) {
          this.$refs.SnackbarQV.print(
            "success",
            "Registrata bobina troppo grande, inserire codice bobina successiva.",
            10000
          );
        } else if (
          // Se la causale è lo scarto produzione...
          this.id_causale_sel != null &&
          this.id_causale_sel === this.id_scarto_prod
        ) {
          this.$refs.SnackbarQV.print(
            "success",
            "Registrato scarto produzione, inserire codice bobina successiva.",
            10000
          );
        }
      },
    },
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getCausaliScarto();
          this.getProgressivoScatole();
        }
      },
    },
  },
  methods: {
    aggiungiImg(messaggio) {
      /* Recupero l'immagine nel messaggio
       * che è un base64 non splittato. */
      let photo = messaggio.detail.img;

      // Uso il base64 per valorizzare la src di un oggetto immagine
      let img = new Image();

      img.onload = function () {
        /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
         * e dimensiono il div in maniera da accoglierla senza stretcharla.
         * Voglio che le dimensioni dell'immagine non siano mai
         * superiori a 150 px; se lo sono scalo le dimesioni.*/
        if (img.width >= img.height && img.width > 150) {
          let width_nuova = 150;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let height_nuova = (width_nuova * img.height) / img.width;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
          img.width = width_nuova;
          img.height = height_nuova;
        } else if (img.height > img.width && img.height > 150) {
          let height_nuova = 150;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let width_nuova = (height_nuova * img.width) / img.height;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
        } else {
          document.getElementById(messaggio.detail.id).style.width =
            img.width + "px";
          document.getElementById(messaggio.detail.id).style.height =
            img.height + "px";
        }
      };

      img.src = photo;

      document.getElementById(messaggio.detail.id).style.backgroundImage =
        'url("' + img.src + '")';

      this.img = messaggio.detail.img;
    },
    clickCambioAftMatNokOk() {
      // Metto a false mat_nok_avvenuta per nascondere la riga di scelta
      this.mat_nok_avvenuta = false;

      // Metto a true cambio_aft_mat_nok per procedere a prendere la nuova bobina.
      this.cambio_aft_mat_nok = true;
    },
    clickCamera() {
      // Faccio scattare la finestra della fotocamera
      this.controllo_webcam_visible = true;
    },
    clickChiudi() {
      // Resetto le variabili di supporto
      this.resetProperties();

      /* Resetto la snackbar così se i 10 secondi
       * non sono ancora passati quando riapro il
       * dialog la snackbar non si fa più vedere. */
      this.$refs.SnackbarQV.chiudi();

      /* Emetto un evento per gestire nel padre
       * la chiusura della finestra di dialogo. */
      this.$emit("click_chiudi");
    },
    clickQRCode() {
      this.qr_reader_visible = true;
      this.camera = "auto";
    },
    confermaCambio(modalita) {
      // Attivo l'overlay di caricamento
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "gestiscibobina",
          token: localStorage.getItem("user_token"),
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_articolo_wo: this.work_order_sel.id_articolo,
          tipo_operazione: "c",
          id_macchina: this.work_order_sel.id_macchina,
          id_causale: this.id_causale_sel,
          img: this.img,
          QRcode: modalita === "qr" ? this.cod_bobina : `${this.cod_bobina}`,
          progressivo_scatole: this.progressivo_scatole,
        },
      };

      // Elimino dalla request i campi che eventualmente non servono.
      if (
        request.richiesta.img === null ||
        request.richiesta.img === "" ||
        request.richiesta.img === undefined
      ) {
        delete request.richiesta.img;
      }
      if (request.richiesta.id_causale === null) {
        delete request.richiesta.id_causale;
      }
      if (request.richiesta.progressivo_scatole === null) {
        delete request.richiesta.progressivo_scatole;
      }

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento_dati = false;

            const cod_tmp = this.cod_bobina;
            this.resetProperties();

            /* Resetto la snackbar in modo che non possa
             * più essere presente alla riapertura del dialog. */
            this.$refs.SnackbarQV.chiudi();
            this.$emit(
              "cambio_avvenuto",
              cod_tmp.split("(P)")[1].split(";")[0]
            );
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
            );
          }

          // Fermo l'overlay di caricamento.
          this.caricamento_dati = false;
        })
        .catch((err) => {
          // Fermo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Resetto le variabili di supporto
          this.resetProperties();
          console.log(err.response.data.message);
          this.$emit(
            "cambio_avvenuto_con_errore",
            JSON.parse(err.response.data.message).result
          );
        });
    },
    handleCloseQRDialog() {
      this.qr_reader_visible = false;
      this.camera = "off";
    },
    handleCloseTermProd() {
      this.termina_produzione_visible = false;
    },
    chiudiDialogMancataDichiarazione() {
      this.dialog_mancata_dichiarazione = false;
    },
    getCausaliScarto() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          db_name: "quickproduction",
          tipo: "PRODUZIONE_CAUSALI",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        // Svuoto gli array delle causali
        this.array_causale = [];

        res.data.forEach((e) => {
          if (e.cod === "105") {
            this.id_non_conf = e.id_tabella;
            e.des = "Materia prima non conforme";
            this.array_causale.push(Object.assign(e));
          }
          if (e.cod === "050") {
            this.id_mancata_dichiarazione = e.id_tabella;
            e.des = "Mancata dichiarazione";
            this.array_causale.push(Object.assign(e));
          }
          if (e.cod === "281") {
            this.id_scarto_prod = e.id_tabella;
            e.des = "Scarto prodotto finito";
            this.array_causale.push(Object.assign(e));
          }
          if (e.cod === "155") {
            this.id_bobina_esaurita = e.id_tabella;
            e.des = "Bobina piccola";
            this.array_causale.push(Object.assign(e));
          }
          if (e.cod === "095") {
            this.id_bobina_eccessiva = e.id_tabella;
            e.des = "Bobina grande";
            this.array_causale.push(Object.assign(e));
          }
        });
      });
    },
    getProgressivoScatole() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprogressivoscatole",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            let pz_per_scatola_tmp =
              this.pz_per_scatola === 0 ? 1 : this.pz_per_scatola;
            console.log(res.data.progressivo[0].qta_totale, pz_per_scatola_tmp);
            this.scatole_prodotte =
              res.data.progressivo[0].qta_totale / pz_per_scatola_tmp;
          } else {
            this.scatole_prodotte = null;
            this.$refs.SnackbarQV.print(
              "orange",
              `Non sono stati trovati dati relativi ai pezzi per scatola dell'articolo in avanzamento, codice ${res.status}.`,
              10000
            );
          }
        })
        .catch(() => {
          this.scatole_prodotte = null;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server."
          );
        });
    },
    handleDichAvv(arg) {
      this.dichiarazione_avvenuta = true;
      this.dialog_mancata_dichiarazione = false;
      this.progressivo_scatole = arg;
      this.$refs.SnackbarQV.print(
        "success",
        "Dichiarazione registrata, inserire codice bobina successiva.",
        10000
      );
    },
    handleMatNokAvv() {
      this.mat_nok_avvenuta = true;
      this.termina_produzione_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrata materia prima non conforme, inserire codice bobina successiva.",
        10000
      );
    },
    handleOnDecode(arg) {
      this.cod_bobina = arg;
      this.camera = "off";
      this.qr_reader_visible = false;
      this.confermaCambio("qr");
    },
    resetProperties() {
      // Variabili d'appoggio
      this.cod_bobina = "";
      this.dichiarazione_avvenuta = false;
      this.id_bobina_eccessiva = null;
      this.id_bobina_esaurita = null;
      this.id_mancata_dichiarazione = null;
      this.id_non_conf = null;
      this.id_scarto_prod = null;
      this.id_causale_sel = null;
      this.img = "";
      this.mat_nok_avvenuta = false;
      this.progressivo_scatole = null;
      this.scatole_prodotte = null;

      // Modal
      this.cambio_aft_mat_nok = false;
      this.camera = "off";
      this.caricamento_dati = false;
      this.controllo_webcam_visible = false;
      this.qr_reader_visible = false;
      this.dialog_mancata_dichiarazione = false;
      this.termina_produzione_visible = false;
    },
  },
  created() {},
  mounted() {
    document
      .getElementById("listener_cambio_bobina")
      .addEventListener("nuova_img", this.aggiungiImg);
  },
};
</script>
<style scoped>
</style>